import {
  DESLogServerLoggerClientOptions,
} from '@des/services/logging';

/**
 * DEFAULT server logger client options for Servicing
 */
export const SERVICING_SERVER_LOGGER_CLIENT_OPTIONS: Partial<DESLogServerLoggerClientOptions> = {
  appName: 'Refx-Servicing'
};
